const blogConstantsEn = {
  thumbnail: 'Thumbnail URL',
  publishSwitch: 'Published',
  minutesOfReading: 'Minutes Of Reading',
  minutesOfReadingValidation: 'Please enter a number greater than 0',
  blogARTags: 'Arabic Tags',
  blogENTags: 'English Tags',
  thumbnailValidation: 'Please enter Thumbnail',
  editBlog: 'Edit Blog',
  newBlog: 'Add New Blog',
  createdBlogSnackbar: 'Blog Created Successfully',
  updatedBlogSnackbar: 'Blog Updated Successfully',
  arabic: 'Arabic',
  english: 'English',
  englishAndArabic: 'English & Arabic',
  published:'published',
  unPublished:'Unpublished'
};

export default blogConstantsEn;
